<template>
  <v-btn color="primary" small class="ml-4" @click="enviarEmails">
    <v-icon :size="18" class="mr-1">mdi-email</v-icon>
    Enviar e-mails
  </v-btn>
</template>

<script setup>
import store from "@/store";
import * as req from "@/api/drp/SeparacaoAutomatica/Emails";
import {logout} from "@/helpers";

function enviarEmails() {
  store.dispatch('loading/addRequisicao', req.enviarEmails().catch(logout));
}
</script>

<style scoped>

</style>
